<template>
<div class="compras-table">
    <table class="table">
        <tr>
            <th>ID</th>
            <th>Producto</th>
            <th >Fecha</th>
            <th >Método de pago</th>
            <th >Total</th>
            <th v-if="tipo_compra == 'pendientes' "></th>
            <th v-if="tipo_compra == 'compras'"></th>
            <th v-if="tipo_compra == 'moviles'">Salir</th>
        </tr>
        <tr
            v-for="(tableRow, i) in tableRows"
            :key="i">
            <td>{{ tableRow.num_compra }}</td>
            <td ><span v-if="tableRow.detalles_compras && tableRow.detalles_compras.compras_productos.length>0">
                <router-link
                v-if="tableRow.metodo_pago!='OneClick' && tableRow.metodo_pago!='PaypalSuscripcion'"
                :to="{
                    name: 'curso',
                    params: {
                        guid: (typeof getCategoriaProducto(tableRow.detalles_compras.compras_productos[0]) !== 'undefined') ? getCategoriaProducto(tableRow.detalles_compras.compras_productos[0]).guid : ''
                        }
                    }">
                    {{ tableRow.detalles_compras.compras_productos[0].producto }}
                </router-link>
                <span v-else >
                    {{ tableRow.detalles_compras.compras_productos[0].producto }}
                </span>
            </span></td>
             <td v-if="tableRow.metodo_pago!='OneClick' && tableRow.metodo_pago!='PaypalSuscripcion'  && tableRow.metodo_pago!='Movistar' && tableRow.metodo_pago!='Entel' && tableRow.metodo_pago!='Wom'">{{ formatDate(tableRow.fecha) }}</td>
            <td v-if="tableRow.metodo_pago=='OneClick' || tableRow.metodo_pago=='PaypalSuscripcion' || tableRow.metodo_pago=='Movistar' || tableRow.metodo_pago=='Entel' || tableRow.metodo_pago=='Wom'">{{ formatDate(tableRow.fecha) }} / <span v-if=" tableRow.detalles_compras" >{{tableRow.detalles_compras.fecha_fin}}</span></td>
            <td >{{ tableRow.metodo_pago }}</td>
            <td ><span v-if="pasarela_precio(tableRow.metodo_pago)!=''">
                {{formatCurrency(pasarela_precio(tableRow.metodo_pago))}}
                </span>
                <span v-else>
                {{ formatCurrency(tableRow.total) }}
                </span>
                </td>
            <td v-if="tipo_compra == 'pendientes' ">
                <button class="btn btn-primary"
                     v-if="tableRow.estado_compra == 'PENDIENTE_PAGO' && tableRow.metodo_pago.toUpperCase() != 'TRANSFERENCIA'"
                    @click="VerificarCompra(tableRow.id)">
                    Reintentar
                </button>
                <button v-if="tableRow.estado_compra == 'PENDIENTE_PAGO' && tableRow.metodo_pago.toUpperCase() == 'TRANSFERENCIA'"
                    class="btn btn-primary"
                    @click="notificarTransferencia(tableRow.id)">
                    Notificar
                </button>
                <span v-if="tableRow.estado_compra == 'PROCESANDO' && tableRow.metodo_pago.toUpperCase() == 'TRANSFERENCIA'"
                    >
                    Esperando Confirmación
                </span>
            </td>
            <td v-if="tipo_compra == 'compras'">
                    <span v-if="tableRow.estado_compra == 'PAGADA'"
                    >
                    Activa
                </span>
            </td>
            <td v-if="tipo_compra == 'moviles' && tableRow.metodo_pago =='Entel'">
                     <button v-if="tableRow.estado_compra == 'PAGADA_SUSCRITO'"
                    class="btn btn-primary"
                    @click="bajar_suscripcion_movil(tableRow.incriptionid)">
                    SALIR
                </button>
                    <span v-else>BAJA</span>
            </td>
            <td v-if="tipo_compra == 'moviles' && tableRow.metodo_pago !='Entel'">
                     <span v-if="tableRow.estado_compra == 'PAGADA_SUSCRITO'">
                        SUSCRITO
                     </span>
                    <span v-else>BAJA</span>
            </td>
        </tr>


        <!-- Compras regaldas-->
        <tr
            v-for="tableRowRega in tableRowsRegalo"
            :key="tableRowRega.id">
            <td>{{ tableRowRega.num_compra }}</td>
            <td><span v-if="tableRowRega.detalles_compras && tableRowRega.detalles_compras.compras_productos.length>0">
                <router-link :to="{
                    name: 'curso',
                    params: {
                        guid: (typeof getCategoriaProducto(tableRow.detalles_compras.compras_productos[0]) !== 'undefined') ? getCategoriaProducto(tableRow.detalles_compras.compras_productos[0]).guid : ''
                        }
                    }">
                    {{ tableRowRega.detalles_compras.compras_productos[0].producto }}
                </router-link>
            </span></td>
            <td >{{ formatDate(tableRowRega.fecha) }}</td>
            <td >{{ tableRowRega.metodo_pago }}</td>
            <td >{{ formatCurrency(tableRowRega.total) }}</td>
            <td v-if="tipo_compra == 'pendientes' ">
                <button class="btn btn-primary"
                     v-if="tableRowRega.estado_compra == 'PENDIENTE_PAGO' && tableRowRega.metodo_pago.toUpperCase() != 'TRANSFERENCIA'"
                    @click="VerificarCompra(tableRowRega.id)">
                    Reintentar
                </button>
                <button v-if="tableRowRega.estado_compra == 'PENDIENTE_PAGO' && tableRowRega.metodo_pago.toUpperCase() == 'TRANSFERENCIA'"
                    class="btn btn-primary"
                    @click="notificarTransferencia(tableRowRega.id)">
                    Notificar
                </button>
                <span v-if="tableRowRega.estado_compra == 'PROCESANDO' && tableRowRega.metodo_pago.toUpperCase() == 'TRANSFERENCIA'"
                    >
                    Esperando Confirmación
                </span>
            </td>
            <td v-if="tipo_compra == 'compras'">
                    <span v-if="tableRowRega.estado_compra == 'PAGADA'"
                    >
                    Regalo
                </span>
            </td>
        </tr>
    </table>

    <b-modal v-model="isTransferenciaModalVisible"
        :busy="true"
        centered
        hide-footer
        title="Notificar Transferencia">
        <transferencia-form
            :id_compra="transferencia_id_compra"
            @submit="transferenciaEnviada" />
    </b-modal>

    <b-modal v-model="isBajaModalVisible"
        :busy="true"
        centered
        hide-footer
        title="Notificación">
         <div
            class="text-center alert-text-box">
            <p>{{this.messageBaja}}</p>
        </div>

    </b-modal>
</div>
</template>

<script>
import { mapState } from "vuex";
import { format, toDate } from "date-fns";
import { es } from "date-fns/esm/locale";
import numeral from "numeral";
import "numeral/locales";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import TransferenciaForm from "../components/TransferenciaForm";

numeral.locale("es");

export default {
	props: ["compras","compras_regaladas","tipo_compras"],
	components: {
		bModal,
		TransferenciaForm
	},
	directives: { "b-modal": bModalDirective },
	data() {
		return {
			tipo_compra: this.tipo_compras,
			isTransferenciaModalVisible: false,
            transferencia_id_compra: 0,
            isBajaModalVisible:false,
            messageBaja:""
		};
	},
	computed: {

        tableRowsRegalo(){
			return this.compras_regaladas;
        },
		tableRows() {
			return this.compras;
        },
		...mapState(["portal"])
	},
	methods: {

        pasarela_precio(pasarela){
            let pasarela_result="";
            this.portal.pasarelas.forEach(
				pasarelas => {

                    if(pasarelas.is_movil==1  &&  pasarela.toLowerCase() == pasarelas.pasarela.toLowerCase()){

                       pasarela_result=pasarelas.precio;
                    }
                });


        return pasarela_result;

        },
		formatDate(date) {
			return format(toDate(date), "dd-MM-YYYY");
		},
		formatCurrency(amount) {
			return numeral(amount).format("$0,0");
		},
		VerificarCompra(id_compra) {
			this.$api
				.verificar_compra_pendiente(id_compra)
				.then(response => {
					console.log(response.data.response);
                window.location =response.data.response;
				})
				.catch(error => {
					console.log("error");
				});
		},
		bajar_suscripcion_movil(inscriptionId) {


            let newUserData = {
				operador: 2,
				action: "BAJA",
				comando: "SALIR",
				inscriptionId: inscriptionId,
            };


			this.$api
				.action_suscripcion_operadores(newUserData)
				.then(response => {
                    console.log("BAJA :",response.data.response);
                    if(response.data.response=="200"){
                        this.isBajaModalVisible=true;
                        this.messageBaja="Se ha dado de baja exitosamente";
                        setInterval(()=>{
                         location.reload();
                        },5000);
                    }else{
                     this.isBajaModalVisible=true;
                     this.messageBaja="Error al realizar baja del servicio";

                    }
				    })
				.catch(error => {
					console.log("error");
				});
		},
		notificarTransferencia(id_compra) {
			this.transferencia_id_compra = id_compra;
			this.isTransferenciaModalVisible = true;
		},
		transferenciaEnviada() {},
		getCategoriaProducto(producto) {
			//console.log({ producto });
			if (producto.compras_productos_categoria.length > 0)
				return this.portal.categorias.find(
					cat =>
						cat.id ==
						producto.compras_productos_categoria[0].id_categoria
				);
		}
	}
};
</script>

